/**
 * In-app path to restore after login. Rejects off-site and login loops.
 * @param {unknown} raw
 * @returns {string}
 */
export function safeAppReturnPath(raw) {
  if (typeof raw !== 'string') return '';
  const value = raw.trim();
  if (!value.startsWith('/') || value.startsWith('//')) return '';
  if (value.includes('\\') || value.includes('://')) return '';
  if (value.length > 512) return '';
  const pathOnly = value.split('?')[0].split('#')[0];
  if (pathOnly === '/login' || pathOnly === '/logout' || pathOnly.startsWith('/login/') || pathOnly.startsWith('/logout/')) {
    return '';
  }
  return value;
}

/** @type {Set<() => Promise<void> | void>} */
const beforeSessionLogoutHandlers = new Set();

/**
 * Pilot keeps the idle timer in App.vue. Pages register a save here.
 * @param {() => Promise<void> | void} handler
 * @returns {() => void}
 */
export function registerBeforeSessionLogout(handler) {
  beforeSessionLogoutHandlers.add(handler);
  return () => {
    beforeSessionLogoutHandlers.delete(handler);
  };
}

export async function runBeforeSessionLogout() {
  const jobs = [...beforeSessionLogoutHandlers].map((handler) => (
    Promise.resolve().then(() => handler())
  ));
  await Promise.race([
    Promise.allSettled(jobs),
    new Promise((resolve) => {
      setTimeout(resolve, 4000);
    }),
  ]);
}
